import { DeleteBoard, DeleteBoardVariables } from './__generated__/DeleteBoard'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteBoard($input: DeleteBoardInput!) {
    deleteBoard(input: $input) {
      deleted
    }
  }
`

export const useDeleteBoard = () => useMutation<DeleteBoard, DeleteBoardVariables>(MUTATION)
